/**
 * Created by slava on 9/8/17
 */

const ColorBoosterView = FieldBoosterView.extend({
    getAnimationPosition: function () {
        return BaseCellView.alignInTheGrid(this.booster.targetCell.x, this.booster.targetCell.y);
    },

    setAnimationZOrder: function (animation) {
        animation.setLocalZOrder(100);
    },

    onHurtCellsAnimation: function () {
        const position = this.getAnimationPosition();

        const fieldView = Game.currentGame.field.onGetView();

        const animation = new cleverapps.Spine(bundles.game.jsons.colorbooster_spine_json);
        this.setAnimationZOrder(animation);
        animation.setPosition(position);
        fieldView.addChild(animation);

        animation.setAnimation(0, "animation", false);
        animation.setCompleteListener(() => {
            animation.runAction(new cc.Sequence(
                new cc.CallFunc(() => {
                    if (Game.currentGame) {
                        Game.currentGame.bigExplode();
                    }
                }),
                new cc.RemoveSelf()
            ));
        });

        cleverapps.effects.fire("match3.booster.rocket.use");
    }
});